import { CommonModule, NgOptimizedImage } from '@angular/common';
import { NO_ERRORS_SCHEMA, NgModule } from '@angular/core';

import { LazyLoadDirective } from '@shared/utils/directives';
import { MediaComponent } from './media.component';
import { MediaHomrAssetComponent } from './media-homr-asset/media-homr-asset.component';
import { MediaScene7Component } from './media-scene7/media-scene7.component';
import { MediaVideoComponent } from './media-video/media-video.component';

/**
 * Media Module
 */
@NgModule({
	imports: [
		CommonModule,
		LazyLoadDirective,
		NgOptimizedImage
	],
	declarations: [MediaComponent, MediaHomrAssetComponent, MediaScene7Component, MediaVideoComponent],
	exports: [MediaComponent, MediaHomrAssetComponent, MediaScene7Component, MediaVideoComponent],
	schemas: [NO_ERRORS_SCHEMA]
})

export class MediaModule {}
